/* eslint-disable react/no-deprecated */
/* eslint class-methods-use-this: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SessionStore from 'stores/SessionStore';
import moment from 'moment';
import DriverStore from 'stores/DriverStore';
import DriverWebAPIUtils, { DOCUMENTS_PER_PAGE } from 'utils/DriverWebAPIUtils';
import Badge from 'components/v2/Badge';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell, } from 'components/ui/table';
import { getSignedUrl } from 'utils/DocumentsAPIUtils';
import { getFileIconClass } from '../../../../helpers/helper_functions';
import Pagination from 'components/v2/PaginationV2';
class DriverDocuments extends React.Component {
    constructor(props) {
        super(props);
        this.componentDidMount = () => {
            DriverStore.addChangeListener(this.getManifests);
            this.loadManifests(1);
        };
        /** *************  COMPONENT STATE HANDLERS ******************** */
        this.getManifests = () => {
            const manifest = DriverStore.getManifest();
            const manifestsMeta = DriverStore.getManifestsMeta();
            this.setState({
                documents: manifest || [],
                manifestsMeta,
                isLoading: false,
            }, () => {
                if (manifest && manifest.length > 0) {
                    this.getSignedUrl();
                }
            });
        };
        this.loadManifests = (page = 1, driverId = null) => {
            const id = driverId || this.props.id;
            this.setState({ isLoading: true });
            DriverWebAPIUtils.getDriverManifests(id, {
                page,
                per_page: DOCUMENTS_PER_PAGE,
            });
        };
        this.onPageSelect = (page) => {
            this.loadManifests(page);
        };
        this.getSignedUrl = async () => {
            const { t } = this.props;
            // Find document paths
            const docs = this.state.documents;
            const signedUrls = {};
            if (docs.length > 0) {
                try {
                    // userRole from above is not in this.state yet, but we need the value to determine visibility of documents
                    const viewableDocs = this.getViewableDocs(docs, this.state.userRole);
                    const promises = viewableDocs.map(async (d) => {
                        var _a;
                        const docKey = d.uri || d.path;
                        if (docKey) {
                            const { data: signedUrl } = await getSignedUrl(docKey);
                            return { docKey, signedUrl: (_a = signedUrl === null || signedUrl === void 0 ? void 0 : signedUrl.getSignedUrl) === null || _a === void 0 ? void 0 : _a.signedUrl };
                        }
                        console.warn(`${t('DOCUMENT_URI_MISSING', { docName: d.name })}`);
                        return { docKey: null, signedUrl: null };
                    });
                    const results = await Promise.all(promises);
                    results.forEach(({ docKey, signedUrl }) => {
                        if (docKey && signedUrl) {
                            signedUrls[docKey] = signedUrl;
                        }
                    });
                }
                catch (e) {
                    console.error(t('SHIPMENT_DOCUMENT'), t('ERROR_SIGNED_URL'), e);
                }
            }
            this.setState({ signedUrls });
        };
        /** *************  EVENT HANDLERS ******************** */
        // User Clicks Depart Button
        this.departManifest = (doc) => {
            if (!doc) {
                return null;
            }
            const { manifestsMeta } = this.state;
            const currentPage = manifestsMeta.page || 1;
            DriverWebAPIUtils.departManifest(doc, {
                onSuccess: () => {
                    // Refetch manifests after successful departure to get updated data
                    this.loadManifests(currentPage);
                },
            });
        };
        const user = SessionStore.getUser();
        this.state = {
            userRole: user._type,
            signedUrls: {},
            documents: [],
            manifestsMeta: {
                total: 0,
                page: 1,
                per_page: DOCUMENTS_PER_PAGE,
                total_pages: 1,
            },
            isLoading: false,
        };
    }
    componentWillReceiveProps(nextProps) {
        // If the user attempts to switch drivers using the search bar, update manifests...
        if (nextProps && nextProps.id !== this.props.id) {
            this.loadManifests(1, nextProps.id);
        }
    }
    componentWillUnmount() {
        DriverStore.removeChangeListener(this.getManifests);
    }
    getViewableDocs(docs, initialUserRole) {
        const userRole = this.state.userRole || initialUserRole;
        return docs.filter((doc) => {
            if (doc.hasOwnProperty('show') && doc.show) {
                if (!doc.user_visibility || userRole === 'Admin') {
                    return true;
                }
                return doc.user_visibility.indexOf(userRole) > -1;
            }
            return false;
        });
    }
    /** *************  VIEW RENDERS  ******************** */
    renderLink(doc) {
        const { t } = this.props;
        const docKey = doc.uri || doc.path;
        const signedUrl = this.state.signedUrls[docKey];
        if (!signedUrl)
            return React.createElement("span", null, t('DOCUMENT_URI_MISSING', { docName: doc.name }));
        return (React.createElement("a", { className: "driver-driverDocuments-viewManifest heap", href: signedUrl, target: "blank" }, doc.name));
    }
    renderDocuments(docs) {
        const scopedDocs = this.getViewableDocs(docs);
        const { t } = this.props;
        return scopedDocs
            .filter((doc) => !!(doc.uri || doc.path))
            .map((doc, i) => {
            const extension = (doc.uri || doc.path).split('.').pop().toUpperCase();
            const key = `shipment-document-${i}`;
            const timestamp = doc.meta && doc.meta.timestamp
                ? moment(doc.meta.timestamp).format('LLLL')
                : '';
            const departed = doc.meta && doc.meta.departed ? doc.meta.departed : false;
            // this is pretty hacky but the only alternative is creating a new component for order docs
            const topItemStyle = i === 0 && this.props.isOrder
                ? { borderTop: '2px solid transparent' }
                : {};
            return (React.createElement(TableRow, { style: topItemStyle, key: key },
                React.createElement(TableCell, null,
                    React.createElement("i", { className: getFileIconClass(extension) })),
                React.createElement(TableCell, null, this.renderLink(doc)),
                React.createElement(TableCell, null, timestamp),
                React.createElement(TableCell, null, !departed ? (React.createElement("button", { type: "primary", className: "button button-green driver-driverDocuments-dispatchDriver heap", onClick: () => this.departManifest(doc) }, t('DEPART'))) : (React.createElement(Badge, { color: "black" }, t('DEPARTED'))))));
        });
    }
    renderPagination() {
        const { manifestsMeta, isLoading } = this.state;
        const { page, per_page, total } = manifestsMeta;
        if (total <= per_page)
            return null;
        return (React.createElement("div", { className: "flex justify-center my-2" },
            React.createElement(Pagination, { perPage: per_page, page: page, total: total, onPageClick: this.onPageSelect, isLoading: isLoading })));
    }
    renderDocumentList() {
        const { t } = this.props;
        const { documents, manifestsMeta } = this.state;
        if (manifestsMeta.total === 0) {
            return React.createElement("i", null, t('DRIVER_DOES_NOT_HAVE_DOCUMENTS'));
        }
        return (React.createElement("div", null,
            React.createElement(Table, null,
                React.createElement(TableHeader, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableHead, null, "Type"),
                        React.createElement(TableHead, null, "Document"),
                        React.createElement(TableHead, null, "Timestamp"),
                        React.createElement(TableHead, null, "Action"))),
                React.createElement(TableBody, null, this.renderDocuments(documents))),
            this.renderPagination()));
    }
    componentDidUpdate(prevProps) {
        // Load manifests if driver ID changes
        if (prevProps.id !== this.props.id) {
            this.loadManifests(1);
        }
    }
    render() {
        return React.createElement("div", null, this.renderDocumentList());
    }
}
DriverDocuments.propTypes = {
    id: PropTypes.string,
};
DriverDocuments.defaultProps = {
    id: '',
};
export default withTranslation()(DriverDocuments);
